import { DefaultFooter } from '@ant-design/pro-components';
import { useIntl } from '@umijs/max';
import { createStyles } from 'antd-style';
import React from 'react';

const useStyles = createStyles(() => ({
  fixedFooter: {
    position: 'fixed',
    left: 0,
    right: 0,
    bottom: 0,
    zIndex: 10,
    '& .ant-pro-global-footer': {
      margin: 0,
      padding: '4px 0',
      background: 'transparent',
    },
    '& .ant-pro-global-footer-copyright': {
      fontSize: 12,
      lineHeight: '20px',
    },
  },
  spacer: {
    height: 28,
  },
}));

const Footer: React.FC = () => {
  const { styles } = useStyles();
  const intl = useIntl();
  return (
    <>
      <div className={styles.spacer} aria-hidden />
      <div className={styles.fixedFooter}>
        <DefaultFooter
          copyright={intl.formatMessage({ id: 'app.footer.copyright' })}
          links={[]}
        />
      </div>
    </>
  );
};

export default Footer;
